// pages/event/event.tsx
import React from "react";
import { Navigate, useParams } from "react-router-dom";

import { useGetEventByIdQuery } from "../../services/store/api/eventsApi";
import EventCardFull from "../../components/event-card/event-card-full";
import Loader from "../../components/loader/loader";
import { NotFound404 } from "../index";

const EventPage = () => {
    const { id } = useParams();    
    const eventId = id ? Number(id) : null;
    const {
        data,
        isLoading,
        isError,
    } = useGetEventByIdQuery(eventId!, {
        skip: !eventId,
    });

    if (isLoading) {
        return <Loader />;
    }
    if (isError) {
        return <Navigate to="/events" replace />;
    }

    const event = data?.event;

    if (!event) {
        return <NotFound404 />;
    }

    return (
        <EventCardFull event={event} />
    );
};

export default EventPage;
